import { inject } from '@angular/core';
import { HttpEvent, HttpRequest, HttpHeaders, HttpHandlerFn, HttpInterceptorFn } from '@angular/common/http';

import { Observable } from 'rxjs';

import { AuthService } from 'src/app/auth/services/auth.service';
import { LocalStorageService } from '../shared/services/local-storage.service';

export const authInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> => {
  if (inject(AuthService).isAuthenticated) {
    const headers = getHeadersWithToken(req);
    req = req.clone({ headers });
  }

  return next(req);
};

const getHeadersWithToken = (request: HttpRequest<any>): HttpHeaders => {
  const token = inject(LocalStorageService).token;
  return request.body instanceof FormData // FormData (uploads) or regular request
    ? request.headers.append('Authorization', 'Bearer ' + token?.key)
    : request.headers.set('Content-Type', 'application/json').append('Authorization', 'Bearer ' + token?.key);
};
